<template>
    <div class="messageContainer">
        <div class="menu">
            <div class="menuContent d-f justify-b align-c">
                <img src="../../image/logo_iol.png" width="193" height="26"/>
                <img class="b-r-cycle" src="../../image/logo_iol.png" width="40" height="40"/>
            </div>
        </div>
        <div class="messMain">
            <header class="c-fff p-l-40 p-t-25">
                <div class="f-s-20 m-b-15">项目公告</div>
                <div class="f-s-14">于 2022年9月2日 12:35 最后编辑</div>
            </header>
            <div class="instruction bg-white p-tb-20 f-s-14 c-222 m-b-12">
                <p>*. 除以下项目规定外，请务必按照<span class="c-309F80">《轻任务常见错误统一规范》</span>进行翻译：</p>
                <p>1. 为使术语统一，页面上可能会有相应的术语提示，请按规定使用术语判断译文结果；</p>
                <p>2. 缩写不翻译（例如PID，EMI不翻译）；</p>
                <p>3. 厂商品牌名称不翻译（例如ABB不翻译）；</p>
                <p>4. 公制单位不翻译（例如kg,kw不翻译）；</p>
                <p>5. 注意低错问题（数字，漏译，标点符号）；</p>
                <p>6. 不确定的单词请通过字典或在网上查验；</p>
            </div>
            <div class="infoBox bg-white p-tb-20 m-b-12">
                <div class="c-333 f-s-16 m-b-15">项目留言<span class="f-s-12">（已有28349条留言）</span></div>
                <el-input type="textarea" placeholder="对项目发表一下你的神评妙论吧.." maxlength="600" show-word-limit resize="none" rows="4" v-model="messageText"></el-input>
                <div :class="[fileImgList.length ? 'bigUpload m-t-15 d-f justify-b align-t' : 'miniUpload m-t-15 d-f justify-b align-t']">
                    <el-upload
                        ref="upload"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        list-type="picture-card"
                        :on-change="handlechange"
                        :on-success="handleSuccess"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :limit=limit
                    >
                        <i :class="[fileImgList.length ? 'el-icon-plus' : 'el-icon-picture-outline f-s-22 c-bbb']"></i>
                    </el-upload>
                    <!-- <i class="el-icon-picture-outline f-s-22 c-bbb"></i> -->
                    <el-button type="primary" size="mini" class="bg-green m-l-18 h-26">发表</el-button>
                </div>
            </div>
            <div class="bg-white p-b-30">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部留言 " name="allMessage">
                        <ul class="p-lr-40per messageList">
                            <li class="d-f b-b" v-for="(item, index) in 3" :key="index">
                                <div class="portrait">
                                    <img class="b-r-cycle" src="../../image/banner@2x.png"/>
                                </div>
                                <div>
                                    <div class="c-222 f-s-14 m-b-15 f-w-600">用户9273751921</div>
                                    <div class="f-s-14 c-484848 l-h-24 m-b-15">双孔电动削笔器Double-Hole Electric Pencil Sharpener DE001 注意事项Notes ●该产品可用于两种  ●参照电池盒上的指示,正确安装四节五号( AA )电池。使用(建议使用碱性电池或可充电电池) ,</div>
                                    <ul class="imgList d-f m-b-12">
                                        <li class="m-r-20 m-b-5" v-for="(item, index) in 6" :key="index">
                                            <img src="../../image/banner@2x.png" width="100%" height="100%"/>
                                        </li>
                                    </ul>
                                    <div class="actBox d-f justify-b c-999 f-s-13 m-b-15">
                                        <span>2022年9月19日 22:12</span>
                                        <div class="d-f align-c">
                                            <div class="d-f align-c c-p">
                                                <span class="goodBg"></span>
                                                <span class="m-l-5">赞</span>
                                                <span class="m-l-3">11</span>
                                            </div>
                                            <div class="d-f align-c m-l-20 c-p">
                                                <span class="replyBg"></span>
                                                <span class="m-l-5">回复</span>
                                            </div>
                                            <div class="d-f align-c m-l-20 c-p">
                                                <span class="delBg"></span>
                                                <span class="m-l-5">删除</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 进行回复 -->
                                    <!-- <div>
                                        <el-input type="textarea" placeholder="回复 兼职译员344：" maxlength="600" show-word-limit resize="none" rows="1" v-model="messageText"></el-input>
                                        <div class="t-r m-t-13">
                                            <el-button type="primary" size="mini" class="bg-green m-l-18">回复</el-button>
                                        </div>
                                    </div> -->
                                    <!-- 回复内容展示 -->
                                    <div class="replyBox bg-f5 b-r-4 p-r d-f">
                                        <div class="triangle p-a"></div>
                                        <div class="imgBox">
                                            <img class="b-r-cycle" src="../../image/banner@2x.png"/>
                                        </div>
                                        <div class="f-s-14 c-484848">
                                            <div class="c-222 f-s-14 m-b-14 f-w-600">可乐</div>
                                            <div class="l-h-24">回复<span class="f-w-600 c-222 m-lr-10">用户927375192:</span>UED中台组的文档输出还在搭建中，不好意思</div>
                                            <div class="f-s-13 c-999">2022年9月19日 22:12</div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- 分页 -->
                        <div class="t-c m-t-30">
                            <el-pagination background :pager-count="5" layout="prev, pager, next" :total="100"></el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="我的留言" name="myMessage">123</el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'

export default {
    data() {
        return {
            messageText: '', //项目留言
            activeName: 'allMessage',
            dialogImageUrl: '',
            dialogVisible: false,
            fileImgList: [],
            limit: 6, //上传图片长度限制
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },

        handlechange(file, fileList) {
            this.checkLimit(fileList)
        },

        handleSuccess(res, file, fileList) {
            this.fileImgList = fileList;
        },

        handleRemove(file, fileList) {
            this.checkLimit(fileList)
            console.log(file, fileList);
        },
        
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        //检查文件长度
        checkLimit(filelist) {
            const limit = this.limit
            const uploadDom = this.$refs['upload']
            if (filelist.length === limit) {
                uploadDom.$children[1].$el.style.display = 'none'
            } else {
                uploadDom.$children[1].$el.style.display = ''
            }
        },

    },
}
</script>

<style lang="scss" scoped>
.p-lr-40per {
    padding: 0 4%;
}
.messageContainer {
    font-family: Microsoft YaHei;
    background: #F5F5F5;
    height: 100%;
    overflow-y: scroll;
    .menu {
        height: 60px;
        margin-bottom: 15px;
        background: #FFFFFF;
        box-shadow: 0px 6px 20px 0px rgba(0,0,0,0.0400);
        .menuContent {
            width: 100%;
            max-width: 1000px;
            height: 60px;
            margin: 0 auto;
        }
    }
    .messMain {
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;
        header {
            height: 100px;
            background: #23CD9D url("../../image/banner@2x.png") no-repeat top right;
            background-size: contain;
            box-sizing: border-box;
        }
        .instruction {
            padding: 0 4%;
            p {
                margin: 0;
                line-height: 26px;
            }
        }
        .infoBox {
            padding: 0 4%;
        }
        .messageList {
            >li {
                padding: 20px 0;
                .portrait {
                    margin-right: 20px;
                    img {
                        width: 50px;
                        height: 50px;
                    }
                }
                .imgList {
                    flex-wrap: wrap;
                    li {
                        width: 112px;
                        height: 112px;
                        background: #FFFFFF;
                        border: 1px solid #E7E7E7;
                        box-shadow: 0px 3px 6px 0px rgba(149,149,149,0.2000);
                        box-sizing: border-box;
                        padding: 5px;
                    }
                }
                .actBox {
                    .goodBg {
                        width: 16px;
                        height: 16px;
                        background: url('../../image/fab@2x.png') no-repeat;
                        background-size: 16px 16px;
                        &:hover {
                            background: url('../../image/fab-h@2x.png') no-repeat;
                            background-size: 16px 16px;
                        }
                    }
                    .replyBg {
                        width: 16px;
                        height: 16px;
                        background: url('../../image/rep@2x.png') no-repeat;
                        background-size: 16px 16px;
                        &:hover {
                            background: url('../../image/rep-h@2x.png') no-repeat;
                            background-size: 16px 16px;
                        }
                    }
                    .delBg {
                        width: 16px;
                        height: 16px;
                        background: url('../../image/del@2x.png') no-repeat;
                        background-size: 16px 16px;
                        &:hover {
                            background: url('../../image/del-h@2x.png') no-repeat;
                            background-size: 16px 16px;
                        }
                    }
                }
                .replyBox {
                    padding: 20px 30px;
                    .imgBox {
                        margin-right: 20px;
                        img {
                            width: 50px;
                            height: 50px;
                        }
                    }
                }
                .triangle {
                    width: 0px;
                    height: 0px;
                    border-width: 0 20px 20px 20px;
                    border-style: solid;
                    border-color: transparent transparent #F5F5F5 transparent;
                    top: -10px;
                    left: 20px;
                }
            }
        }
        
    }
}
@media screen and (max-width: 1000px) {
    .messageContainer {
        .menu {
            margin-bottom: 10px;
            .menuContent {
                padding: 0 18px;
            }
        }
        .messMain {
            .messageList {
                >li {
                    padding: 12px 0;
                    .portrait {
                        margin-right: 10px;
                        img {
                            width: 35px;
                            height: 35px;
                        }
                    }
                    .imgList {
                        li {
                            width: 85px;
                            height: 85px;
                        }
                    }
                    .replyBox {
                        padding: 10px;
                        .imgBox {
                            margin-right: 10px;
                            img {
                                width: 35px;
                                height: 35px;
                            }
                        }
                        
                    }
                }
            }
        }
    }
}
</style>
